import { Component, OnInit, Inject, Input } from '@angular/core';
import { ActionModel } from '../../actions/action.model';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActionsService } from '../../actions/actions.service';

@Component({
  selector: 'app-user-tasks-tabs',
  templateUrl: './user-tasks-tabs.component.html',
  styleUrls: ['./user-tasks-tabs.component.scss']
})
export class UserTasksTabsComponent implements OnInit {
  is_edit: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { action: ActionModel; is_edit: boolean },
    private actionsService: ActionsService
  ) {
    this.is_edit = data.is_edit;
  }

  ngOnInit() {
    if (this.data?.action?.id) {
      this.actionsService.find(this.data.action.id).subscribe((res: any) => {
        this.data.action = res.data;
      });
    }
  }
}
